'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function buildMfeRemotes(mfeRemotes) {
    if (mfeRemotes === void 0) { mfeRemotes = []; }
    return _assign({}, mfeRemotes
        .filter(function (mfeDependeny) { return typeof (mfeDependeny === null || mfeDependeny === void 0 ? void 0 : mfeDependeny.id) === 'string'; })
        .map(function (mfeDependeny) { return "".concat(mfeDependeny.id); })
        .reduce(function (a, v) {
        var _a;
        return (_assign(_assign({}, a), (_a = {}, _a[v] = v, _a)));
    }, {}));
}

var applyConfig = function (props) {
    var _a = _assign({}, props), pkgDependencies = _a.pkgDependencies, configDeps = _a.configDeps, includedDeps = _a.includedDeps, excludedDeps = _a.excludedDeps, requiredVersion = _a.requiredVersion;
    var dependenciesKeys = Array.isArray(pkgDependencies)
        ? pkgDependencies
        : Object.keys(_assign({}, pkgDependencies));
    return dependenciesKeys
        .filter(function (dep) { return Array.isArray(includedDeps) && includedDeps.includes(dep); })
        .filter(function (dep) { return Array.isArray(excludedDeps) && !excludedDeps.includes(dep); })
        .reduce(function (previous, current) {
        var _a;
        return (_assign(_assign({}, previous), (_a = {}, _a[current] = _assign(_assign(_assign({}, configDeps), (requiredVersion &&
            pkgDependencies[current] &&
            configDeps.version !== '0' && {
            requiredVersion: pkgDependencies[current],
        })), (typeof requiredVersion !== 'undefined' &&
            requiredVersion === false && {
            requiredVersion: requiredVersion,
        })), _a)));
    }, {});
};
function getShareDependencies(props) {
    var _a = _assign({}, props), _b = _a.pkgDependencies, pkgDependencies = _b === void 0 ? {} : _b, _c = _a.eagerDeps, eagerDeps = _c === void 0 ? [] : _c, _d = _a.configEagerDeps, configEagerDeps = _d === void 0 ? {} : _d, _e = _a.excludedDeps, excludedDeps = _e === void 0 ? [] : _e, _f = _a.lazyDeps, propLazyDeps = _f === void 0 ? {} : _f, _g = _a.configLazyDeps, configLazyDeps = _g === void 0 ? {} : _g;
    var lazyDeps = Array.isArray(propLazyDeps) ? propLazyDeps : Object.keys(_assign({}, pkgDependencies));
    // @ts-expect-error default value no needed
    var _h = _assign({}, (!Array.isArray(configEagerDeps) && _assign({}, configEagerDeps))), eagerRequiredVersion = _h.requiredVersion, _configEagerDeps = __rest(_h, ["requiredVersion"]);
    var eagerDepsObjs = applyConfig({
        requiredVersion: eagerRequiredVersion,
        pkgDependencies: pkgDependencies,
        includedDeps: eagerDeps,
        configDeps: _assign({}, _configEagerDeps),
        excludedDeps: __spreadArray(__spreadArray([], lazyDeps.filter(function (lazyDep) { return Array.isArray(eagerDeps) && !eagerDeps.includes(lazyDep); }), true), (excludedDeps !== null && excludedDeps !== void 0 ? excludedDeps : []), true),
    });
    // @ts-expect-error no default value needed
    var _j = _assign({}, configLazyDeps), lazyRequiredVersion = _j.requiredVersion, _configLazyDeps = __rest(_j, ["requiredVersion"]);
    var lazyDepsObjs = applyConfig({
        requiredVersion: lazyRequiredVersion,
        pkgDependencies: pkgDependencies,
        includedDeps: lazyDeps,
        configDeps: _assign({}, _configLazyDeps),
        excludedDeps: __spreadArray(__spreadArray([], Array.from(eagerDeps || []), true), Array.from(excludedDeps || []), true),
    });
    return _assign(_assign({}, lazyDepsObjs), eagerDepsObjs);
}

var handleLoad = function (container) { return ({
    // @ts-expect-error Helpers from webpack
    get: function (request) { return container.get(request); },
    // @ts-expect-error Helpers from webpack
    init: function (arg) {
        try {
            // @ts-expect-error Helpers from webpack
            return container.init(arg);
        }
        catch (err) {
            // @ts-expect-error throws an exception
            return new Error(err);
        }
    },
}); };
var handleError = function (id, err) {
    return new Error("Failed to fetch remote: ".concat(id, " ").concat(err));
};
/**
 * Helper to fetch remote module and inject it in DOM (script)
 */
var fetchRemote = function (url, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                try {
                    var script = document.createElement('script');
                    script.src = url;
                    script.type = 'text/javascript';
                    script.async = true;
                    script.onerror = function (err) { return resolve(handleError(id, err)); };
                    script.onload = function () { return resolve(handleLoad(window[id])); };
                    document.head.appendChild(script);
                }
                catch (err) {
                    // TODO: Check if we could implement reject instead of resolve
                    resolve(handleError(id, err));
                }
            })];
    });
}); };

var getRemoteEntryFromManifest = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response, assets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                assets = _a.sent();
                if (!assets.remoteEntry) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, assets.remoteEntry];
        }
    });
}); };
var loadComponent = function (_a) {
    var id = _a.id, remoteEntry = _a.remoteEntry, manifest = _a.manifest, moduleName = _a.moduleName, scope = _a.scope, _b = _a.fallback, fallback = _b === void 0 ? function () { return React__default["default"].createElement(React__default["default"].Fragment, null); } : _b;
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var sharingScope, remoteEntryFromManifest, fetchedContainer, container, factory, Module;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sharingScope = scope !== null && scope !== void 0 ? scope : 'default';
                    remoteEntryFromManifest = remoteEntry;
                    if (!!(id in window)) return [3 /*break*/, 6];
                    // @ts-expect-error helper from webpack
                    return [4 /*yield*/, __webpack_init_sharing__(sharingScope)];
                case 1:
                    // @ts-expect-error helper from webpack
                    _a.sent();
                    if (!manifest) return [3 /*break*/, 3];
                    return [4 /*yield*/, getRemoteEntryFromManifest(manifest)];
                case 2:
                    remoteEntryFromManifest = _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, fetchRemote("".concat(remoteEntryFromManifest === null || remoteEntryFromManifest === void 0 ? void 0 : remoteEntryFromManifest.replace(/\/$/, '')), id)];
                case 4:
                    fetchedContainer = _a.sent();
                    // @ts-expect-error container could be wrong initialized
                    if (!(fetchedContainer === null || fetchedContainer === void 0 ? void 0 : fetchedContainer.get)) {
                        return [2 /*return*/, Promise.resolve({ default: fallback })];
                    }
                    /* Initialize the container with shared dependencies for this remote component */
                    // @ts-expect-error helper from webpack
                    return [4 /*yield*/, fetchedContainer.init(__webpack_share_scopes__[sharingScope])];
                case 5:
                    /* Initialize the container with shared dependencies for this remote component */
                    // @ts-expect-error helper from webpack
                    _a.sent();
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    container = window[id];
                    return [4 /*yield*/, container.get("./".concat(moduleName))];
                case 7:
                    factory = _a.sent();
                    Module = factory();
                    return [2 /*return*/, Module];
                case 8:
                    _a.sent();
                    return [2 /*return*/, Promise.resolve({ default: fallback })];
                case 9: return [2 /*return*/];
            }
        });
    }); };
};

var MfeRemoteComponent = function (_a) {
    var _b = _a.id, id = _b === void 0 ? '' : _b, remoteEntry = _a.remoteEntry, manifest = _a.manifest, moduleName = _a.moduleName, _c = _a.scope, scope = _c === void 0 ? 'default' : _c, _d = _a.loading, loading = _d === void 0 ? React__default["default"].createElement(React__default["default"].Fragment, null, "Loading...") : _d, _e = _a.fallback, fallback = _e === void 0 ? React__default["default"].createElement("div", null, "there was an error...") : _e, props = __rest(_a, ["id", "remoteEntry", "manifest", "moduleName", "scope", "loading", "fallback"]);
    if (!moduleName) {
        return React__default["default"].createElement("h2", null, "moduleName property is required");
    }
    var Component = React__default["default"].lazy(loadComponent({ id: id, remoteEntry: remoteEntry, manifest: manifest, moduleName: moduleName, scope: scope, fallback: function () { return fallback; } }));
    var show = typeof window !== 'undefined';
    return (show && (React__default["default"].createElement(React__default["default"].Suspense, { fallback: loading },
        React__default["default"].createElement(Component, _assign({}, props)))));
};

var Fallback = function () { return React__default["default"].createElement("div", null, "Not found"); };
var WithMfeRemote = function (remotes) {
    var WrappedMfeRemote = function (_a) {
        var id = _a.id, _b = _a.fallback, fallback = _b === void 0 ? React__default["default"].createElement(Fallback, null) : _b, _c = _a.scope, scope = _c === void 0 ? 'default' : _c, props = __rest(_a, ["id", "fallback", "scope"]);
        var remoteId = id.replace(/-/g, '_');
        var configProps = remotes === null || remotes === void 0 ? void 0 : remotes.find(function (_a) {
            var idDependency = _a.id;
            return idDependency.replace(/-/g, '_') === remoteId;
        });
        var _d = _assign({}, configProps), remoteEntry = _d.remoteEntry, moduleName = _d.moduleName;
        if (!remoteEntry || !moduleName)
            return fallback;
        return (React__default["default"].createElement(MfeRemoteComponent, _assign({ id: remoteId, moduleName: moduleName, remoteEntry: remoteEntry, scope: scope, fallback: fallback }, props)));
    };
    return WrappedMfeRemote;
};

exports.MfeRemoteComponent = MfeRemoteComponent;
exports.WithMfeRemote = WithMfeRemote;
exports.buildMfeRemotes = buildMfeRemotes;
exports.getSharedDependencies = getShareDependencies;
exports.loadComponent = loadComponent;
//# sourceMappingURL=index.js.map
